const legacyIsMobileCheck = (userAgent) => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
const isMobileUserAgent = process.client
  && navigator.userAgentData
  && navigator.userAgentData.mobile;
const getUserAgent = () => (process.client && navigator.userAgent) || '';

export const isMobile = typeof isMobileUserAgent === 'boolean'
  ? isMobileUserAgent
  : legacyIsMobileCheck(getUserAgent());
export const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(getUserAgent());

export const isFirefox = () => process.client && typeof window.InstallTrigger !== 'undefined';
